export default __webpack_public_path__ + "static/cat-f22b8f18a9afd6f0810db6ce3ff3810c.png";